module.exports = __webpack_public_path__ + "static/media/fb-share.e794d273.svg";